module.exports = "./dist/dmap/leaflet/layers-2x.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/leaflet/dist/images/layers-2x.png
// module id = 102
// module chunks = 0